import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PaymentMethodIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PaymentMethodIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <g clipPath="url(#clip0_2231_4742)">
        <path
          d="M21.7 5H2.5C1.67157 5 1 5.67957 1 6.51786V18.6607C1 19.499 1.67157 20.1786 2.5 20.1786H21.7C22.5284 20.1786 23.2 19.499 23.2 18.6607V6.51786C23.2 5.67957 22.5284 5 21.7 5Z"
          stroke="#503291"
        />
        <path d="M2 9L23.3333 9" stroke="#503291" />
        <path d="M3 12H10.2" stroke="#503291" strokeLinecap="round" />
        <path d="M4 16H7.6" stroke="#503291" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_2231_4742">
          <rect
            width={24}
            height={17}
            fill="white"
            transform="translate(0 3.5)"
          />
        </clipPath>
      </defs>
    </Icon>
  )
}
export default PaymentMethodIcon
